import { MAP_ELEMENT } from "../../../../../contexts/WorldMapContext/constants";
import { uuid } from "../../../../../util/varibles/global";
import { ITaskService, IUnit } from "../../../../../util/varibles/interface";

export function convertUnit(data: Partial<IUnit>) {
    const { id = '', unit_id = '', } = data;

    return { id, unit_id }
}

export const initTask = (unit: Partial<IUnit> & { location_id: string, location_name: string, note?: string }): ITaskService => {
    const { location_id, location_name, id, note } = unit;
    return {
        duration: 0,
        location_id,
        location_name,
        note,
        location_type: MAP_ELEMENT.SITE,
        group_id: uuid(),
        sub_operations: id ? [convertUnit(unit)] : [],
        error: {},
    }
}

